import { convertCurrencyToNumber } from 'utils/currencyConverter';
import { TRefinancingDebt } from './refinancing.types';

// A debt "counts" as entered once the user has typed a lender, chosen a
// facility type or entered a balance. The section seeds an empty debt
// (`{ facilityType: '' }`), so an untouched form should not read as entered.
export const hasEnteredDebtData = (debts?: TRefinancingDebt[]): boolean =>
  Boolean(
    debts?.some(
      (debt) =>
        debt?.lenderName?.trim() ||
        Boolean(debt?.facilityType) ||
        debt?.outstandingBalance?.trim(),
    ),
  );

// Sum the outstanding balances as whole pounds. We round each balance before
// summing so the total always equals the sum of the debt lines the summary
// shows (both display as whole pounds).
export const getTotalDebt = (
  debts?: Pick<TRefinancingDebt, 'outstandingBalance'>[],
): number =>
  (debts ?? []).reduce(
    (total, debt) =>
      total +
      Math.round(convertCurrencyToNumber(debt?.outstandingBalance) || 0),
    0,
  );
